<template>
  <div class="container">
    <div class="top">
      <van-tabs
        v-model="active"
        class="tabs"
        sticky
        background="white"
        color="#1646C0"
        title-active-color="#1646C0"
        title-inactive-color="rgba(0,0,0,0.3)"
        @click="gettab"
      >
        <van-tab title="推荐">
          <van-list
            v-model="listfjloading"
            :finished="listfjfinished"
            finished-text="没有更多啦"
            :immediate-check="true"
            @load="listfjload_more()"
          >
            <div v-for="(item, index) in listfj" :key="item.id" class="main">
              <div class="maintop" style="margin: 10px 0">
                <img
                  v-if="item.headimg"
                  :src="item.headimg"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <img
                  v-else
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <div>
                  <p>
                    {{ item.member_name
                    }}<span class="level">({{ item.level_str }})</span>
                  </p>
                  <!-- <p class="level" style="color: red">{{ item.org_name }}</p> -->
                  <p class="date">{{ timeTrans(item.createtime) }}</p>
                </div>
                <div
                  class="bt"
                  v-if="my_id != item.m_id"
                  @click="follow(item.m_id, index, listfj)"
                >
                  <p v-show="!item.isfollow">+关注</p>
                  <p v-show="item.isfollow" style="color: #999999">已关注</p>
                </div>
              </div>
              <div>
                <div class="pics" v-show="item.imgs.length > 0">
                  <van-swipe
                    class="my-swipe"
                    indicator-color="white"
                    v-if="item.imgs.length > 0"
                  >
                    <van-swipe-item
                      v-for="(value, index) in item.imgs"
                      :key="index"
                    >
                      <img
                        v-lazy="value"
                        alt=""
                        @click="preview(item.imgs, index)"
                      />
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <div class="video" v-show="item.video">
                  <video
                    :src="item.video"
                    controls
                    preload
                    style="
                      width: 100%;
                      height: 56vw;
                      object-fit: cover;
                      background: black;
                    "
                  ></video>
                </div>
                <p class="content">
                  {{ item.content
                  }}<span @click="totopic(item.task_id)"
                    >#{{ item.task_title }}#</span
                  >
                </p>
                <!-- <p class="date">{{ timeTrans(item.createtime) }}</p> -->
                <!-- <p class="tag" @click="totopic(item.task_id)">
                  来自活动<span>#{{ item.task_title }}#</span>
                </p> -->
                <!-- 评论区，最多显示5个 -->
                <div class="commentzoom">
                  <div
                    v-for="(item2, index2) in item.comments"
                    :key="item2.id"
                    style="margin: 5px auto"
                  >
                    <div
                      class="flex"
                      v-show="
                        index2 < item.showcomment + (item.commentnum - 1) * 10
                      "
                    >
                      <p
                        style="
                          font-size: 14px;
                          color: #333333;
                          font-weight: 600;
                          white-space: nowrap;
                        "
                        @click="tohomepage(item2.m_id)"
                      >
                        {{ item2.m_name }}：
                      </p>
                      <div>
                        <p style="font-size: 14px; color: #666">
                          {{ item2.content }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <van-divider
                    :style="{ color: '#1989fa', padding: '0 16px' }"
                    v-if="
                      item.comments.length >
                      item.showcomment + (item.commentnum - 1) * 10
                    "
                    @click="showmorecomment(listfj, index)"
                  >
                    查看剩余评论
                  </van-divider>
                </div>
                <!-- 完毕 -->
                <!-- <hr /> -->
                <div class="flex" style="margin: 10px 0">
                  <!-- <img
                    :src="tx"
                    v-if="tx"
                    class="txsmall"
                    alt=""
                    @click="tohomepage(my_id)"
                  />
                  <img
                    src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                    v-else
                    class="txsmall"
                    alt=""
                  /> -->
                  <el-input
                    type="textarea"
                    readonly
                    placeholder="随时回应"
                    v-model="item.pinglun"
                    autosize
                    @click.native="choosepinglun(listfj, index)"
                  ></el-input>
                  <van-icon
                    style="margin-left: 10px; margin-top: 5px"
                    name="comment-o"
                    size="24"
                    @click="
                      item.pinglun && send(item.id, item.pinglun, listfj, index)
                    "
                  />
                </div>
                <div class="flexicon">
                  <div
                    @click="
                      share(
                        item.task_id,
                        item.task_title,
                        index,
                        listfj,
                        item.id
                      )
                    "
                  >
                    <img src="static/img/share.png" alt="" />
                    <p>转发</p>
                    <!-- <span>{{ item.zhuanfa }}</span> -->
                  </div>
                  <div
                    @click="shoucang(item.id, index, listfj)"
                    style="margin-left: auto; margin-right: 15px"
                  >
                    <van-icon name="star-o" size="16" v-show="!item.isfav" />
                    <van-icon
                      name="star"
                      size="16"
                      color="#1646C0"
                      v-show="item.isfav"
                    />
                    <!-- <p>{{ item.fav }}</p> -->
                    <p>收藏</p>
                  </div>
                  <div @click="dianzan(item.id, index, listfj)">
                    <van-icon name="like-o" size="16" v-show="!item.iszan" />
                    <van-icon
                      name="like"
                      size="16"
                      color="#1646C0"
                      v-show="item.iszan"
                    />
                    <!-- <p>{{ item.zan }}</p> -->
                    <p>赞</p>
                  </div>
                </div>
              </div>
              <div class="fg"></div>
            </div>
          </van-list>
        </van-tab>
        <van-tab title="关注">
          <van-list
            v-model="listgzloading"
            :finished="listgzfinished"
            :immediate-check="true"
            finished-text="没有更多啦"
            @load="listgzload_more()"
          >
            <div v-for="(item, index) in listgz" :key="item.id" class="main">
              <div class="maintop" style="margin: 10px 0">
                <img
                  v-if="item.headimg"
                  :src="item.headimg"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <img
                  v-else
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <div>
                  <p>
                    {{ item.member_name
                    }}<span class="level">({{ item.level_str }})</span>
                  </p>
                  <!-- <p class="level" style="color: red">{{ item.org_name }}</p> -->
                  <p class="date">{{ timeTrans(item.createtime) }}</p>
                </div>
                <div
                  class="bt"
                  v-if="my_id != item.m_id"
                  @click="follow(item.m_id, index, listgz)"
                >
                  <p v-show="!item.isfollow">+关注</p>
                  <p v-show="item.isfollow" style="color: #999">已关注</p>
                </div>
              </div>
              <div>
                <div class="pics" v-show="item.imgs.length > 0">
                  <van-swipe
                    class="my-swipe"
                    indicator-color="white"
                    v-if="item.imgs.length > 0"
                  >
                    <van-swipe-item
                      v-for="(value, index) in item.imgs"
                      :key="index"
                    >
                      <img
                        v-lazy="value"
                        alt=""
                        @click="preview(item.imgs, index)"
                      />
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <div class="video" v-show="item.video">
                  <video
                    :src="item.video"
                    controls
                    preload
                    style="
                      width: 100%;
                      height: 56vw;
                      object-fit: cover;
                      background: black;
                    "
                  ></video>
                </div>
                <p class="content">
                  {{ item.content
                  }}<span @click="totopic(item.task_id)"
                    >#{{ item.task_title }}#</span
                  >
                </p>
                <!-- <p class="tag" @click="totopic(item.task_id)">
                  来自活动<span>#{{ item.task_title }}#</span>
                </p> -->
                <!-- <hr /> -->

                <!-- 评论区，最多显示5个 -->
                <div class="commentzoom">
                  <div
                    v-for="(item2, index2) in item.comments"
                    :key="item2.id"
                    style="margin: 5px auto"
                  >
                    <div
                      class="flex"
                      v-show="
                        index2 < item.showcomment + (item.commentnum - 1) * 10
                      "
                    >
                      <p
                        style="
                          font-size: 14px;
                          color: #333;
                          font-weight: 600;
                          white-space: nowrap;
                        "
                        @click="tohomepage(item2.m_id)"
                      >
                        {{ item2.m_name }}：
                      </p>
                      <div>
                        <p style="font-size: 14px; color: #666">
                          {{ item2.content }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <van-divider
                    :style="{ color: '#1989fa', padding: '0 16px' }"
                    v-if="
                      item.comments.length >
                      item.showcomment + (item.commentnum - 1) * 10
                    "
                    @click="showmorecomment(listgz, index)"
                  >
                    查看剩余评论
                  </van-divider>
                </div>

                <!-- 完毕 -->
                <div class="flex" style="margin: 10px 0">
                  <!-- <img
                    :src="tx"
                    v-if="tx"
                    class="txsmall"
                    alt=""
                    @click="tohomepage(my_id)"
                  />
                  <img
                    src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                    v-else
                    class="txsmall"
                    alt=""
                  /> -->
                  <el-input
                    type="textarea"
                    readonly
                    placeholder="随时回应"
                    v-model="item.pinglun"
                    autosize
                    @click.native="choosepinglun(listgz, index)"
                  ></el-input>
                  <van-icon
                    style="margin-left: 10px; margin-top: 5px"
                    name="comment-o"
                    size="24"
                    @click="
                      item.pinglun && send(item.id, item.pinglun, listgz, index)
                    "
                  />
                </div>
                <div class="flexicon">
                  <div
                    @click="
                      share(
                        item.task_id,
                        item.task_title,
                        index,
                        listgz,
                        item.id
                      )
                    "
                  >
                    <img src="static/img/share.png" alt="" />
                    <!-- <span>{{ item.zhuanfa }}</span> -->
                    <p>转发</p>
                  </div>
                  <div
                    @click="shoucang(item.id, index, listgz)"
                    style="margin-left: auto; margin-right: 15px"
                  >
                    <van-icon name="star-o" size="16" v-show="!item.isfav" />
                    <van-icon
                      name="star"
                      size="16"
                      color="#1646C0"
                      v-show="item.isfav"
                    />
                    <!-- <span>{{ item.fav }}</span> -->
                    <p>收藏</p>
                  </div>
                  <div @click="dianzan(item.id, index, listgz)">
                    <van-icon name="like-o" size="16" v-show="!item.iszan" />
                    <van-icon
                      name="like"
                      size="16"
                      color="#1646C0"
                      v-show="item.iszan"
                    />
                    <!-- <span>{{ item.zan }}</span> -->
                    <p>赞</p>
                  </div>
                </div>
              </div>
              <div class="fg"></div>
            </div>
          </van-list>
        </van-tab>
        <van-tab title="收藏">
          <van-list
            v-model="listfavloading"
            :finished="listfavfinished"
            :immediate-check="true"
            finished-text="没有更多啦"
            @load="listfavload_more()"
          >
            <div v-for="(item, index) in listfav" :key="item.id" class="main">
              <div class="maintop" style="margin: 10px 0">
                <img
                  v-if="item.headimg"
                  :src="item.headimg"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <img
                  v-else
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                  alt=""
                  @click="tohomepage(item.m_id)"
                />
                <div>
                  <p>
                    {{ item.member_name
                    }}<span class="level">({{ item.level_str }})</span>
                  </p>
                  <!-- <p class="level" style="color: red">{{ item.org_name }}</p> -->
                  <p class="date">{{ timeTrans(item.createtime) }}</p>
                </div>
                <div
                  class="bt"
                  v-if="my_id != item.m_id"
                  @click="follow(item.m_id, index, listfav)"
                >
                  <p v-show="!item.isfollow">+关注</p>
                  <p v-show="item.isfollow" style="color: #999">已关注</p>
                </div>
              </div>
              <div>
                <div class="pics" v-show="item.imgs.length > 0">
                  <van-swipe
                    class="my-swipe"
                    indicator-color="white"
                    v-if="item.imgs.length > 0"
                  >
                    <van-swipe-item
                      v-for="(value, index) in item.imgs"
                      :key="index"
                    >
                      <img
                        v-lazy="value"
                        alt=""
                        @click="preview(item.imgs, index)"
                      />
                    </van-swipe-item>
                  </van-swipe>
                </div>
                <div class="video" v-show="item.video">
                  <video
                    :src="item.video"
                    controls
                    preload
                    style="
                      width: 100%;
                      height: 56vw;
                      object-fit: cover;
                      background: black;
                    "
                  ></video>
                </div>
                <p class="content">
                  {{ item.content
                  }}<span @click="totopic(item.task_id)"
                    >#{{ item.task_title }}#</span
                  >
                </p>
                <!-- <p class="tag" @click="totopic(item.task_id)">
                  来自活动<span>#{{ item.task_title }}#</span>
                </p> -->
                <!-- 评论区，最多显示5个 -->
                <div class="commentzoom">
                  <div
                    v-for="(item2, index2) in item.comments"
                    :key="item2.id"
                    style="margin: 5px auto"
                  >
                    <div
                      class="flex"
                      v-show="
                        index2 < item.showcomment + (item.commentnum - 1) * 10
                      "
                    >
                      <p
                        @click="tohomepage(item2.m_id)"
                        style="
                          font-size: 14px;
                          color: #333;
                          font-weight: 600;
                          white-space: nowrap;
                        "
                      >
                        {{ item2.m_name }}：
                      </p>
                      <div>
                        <p style="font-size: 14px; color: #666">
                          {{ item2.content }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <van-divider
                    :style="{ color: '#1989fa', padding: '0 16px' }"
                    v-if="
                      item.comments.length >
                      item.showcomment + (item.commentnum - 1) * 10
                    "
                    @click="showmorecomment(listfav, index)"
                  >
                    查看剩余评论
                  </van-divider>
                </div>
                <!-- 完毕 -->
                <div class="flex" style="margin: 10px 0">
                  <!-- <img
                    :src="tx"
                    v-if="tx"
                    class="txsmall"
                    alt=""
                    @click="tohomepage(my_id)"
                  />
                  <img
                    src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                    v-else
                    class="txsmall"
                    alt=""
                  /> -->
                  <el-input
                    type="textarea"
                    readonly
                    placeholder="随时回应"
                    v-model="item.pinglun"
                    autosize
                    @click.native="choosepinglun(listfav, index)"
                  ></el-input>
                  <van-icon
                    style="margin-left: 10px; margin-top: 5px"
                    name="comment-o"
                    size="24"
                    @click="
                      item.pinglun &&
                        send(item.id, item.pinglun, listfav, index)
                    "
                  />
                </div>
                <!-- <hr /> -->
                <div class="flexicon">
                  <div
                    @click="
                      share(
                        item.task_id,
                        item.task_title,
                        index,
                        listfav,
                        item.id
                      )
                    "
                  >
                    <!-- zhuanfa(item.id,index,listfav) -->
                    <!-- <van-icon name="share-o" size="14" /> -->
                    <!-- <span>{{ item.zhuanfa }}</span> -->
                    <img src="static/img/share.png" alt="" />
                    <p>转发</p>
                  </div>
                  <div
                    @click="shoucang(item.id, index, listfav)"
                    style="margin-left: auto; margin-right: 15px"
                  >
                    <van-icon name="star-o" size="16" v-show="!item.isfav" />
                    <van-icon
                      name="star"
                      size="16"
                      color="#1646C0"
                      v-show="item.isfav"
                    />
                    <!-- <span>{{ item.fav }}</span> -->
                    <p>收藏</p>
                  </div>
                  <div @click="dianzan(item.id, index, listfav)">
                    <van-icon name="star-o" size="16" v-show="!item.zan" />
                    <van-icon
                      name="star"
                      size="16"
                      color="#1646C0"
                      v-show="item.iszan"
                    />
                    <!-- <span>{{ item.zan }}</span> -->
                    <p>赞</p>
                  </div>
                </div>
              </div>
              <div class="fg"></div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
      <img :src="tx" v-if="tx" class="tx" alt="" @click="tohomepage(my_id)" />
      <img
        src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
        v-else
        class="tx"
        alt=""
        @click="tohomepage(my_id)"
      />
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon01.png"
          class="icon"
          alt=""
          @click="urlchange('/')"
        />
        <p>首页</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icona02.png"
          class="icon"
          alt=""
        />
        <p style="color: #1646c0">澄风show</p>
      </div>
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        placement="top"
      >
        <template #reference>
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/icon05.png"
            style="width: 45px; height: 35px"
            alt=""
          />
        </template>
      </van-popover>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon03.png"
          class="icon"
          alt=""
          @click="urlchange('/eventcenterdetail')"
        />
        <p>活动中心</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon04.png"
          class="icon"
          alt=""
          @click="urlchange('/center')"
        />
        <p>我的家园</p>
      </div>
    </div>
    <!-- new -->
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="comments">
        <p @click="choose()">志愿者最光荣，你们是江阴美丽的风景线。</p>
        <p @click="choose()">这次活动我有事没参加，下次活动请带带我。</p>
        <p @click="choose()">你们真是太棒了，粉了粉了！</p>
        <p @click="choose()">这个活动真不错，我来学习学习！</p>
        <p @click="choose()">已转发已点赞，好的品行要传扬！</p>
        <p @click="choose()">初到贵宝地，看到你们的活动，赞一个！</p>
        <p @click="choose()">咱们队友真是棒棒哒，下次继续一起活动哈！</p>
        <p @click="choose()">这个活动真不错，要继续推广下去！</p>
      </div>
    </van-popup>
    <!-- end -->
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      active: 0,
      listfj: [],
      listfav: [],
      listgz: [],
      org: "",
      tx: "",
      my_id: "",
      listfjloading: false,
      listfjfinished: false,
      listfjpage: 1,
      listgzloading: false,
      listgzfinished: false,
      listgzpage: 1,
      listfavloading: false,
      listfavfinished: false,
      listfavpage: 1,
      showPopover: false,
      actions: [
        { text: "发布报告", icon: "notes-o", className: "0" },
        { text: "发布心愿", icon: "exchange", className: "1" },
        { text: "我的收藏", icon: "like-o", className: "2" },
      ],
      show: false,
      chooselist: "",
      chooselistindex: "",
      member: {},
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
    };
  },
  created() {
    zjyapi.init({
      appId: this.appId,
      error: function (code, ret) {
        //失败回调,默认
        Toast("初始化失败");
      },
      success: function success(ret) {},
    });
    /* 我的信息 */
    this.$axios({
      method: "post",
      url: "/api/home/index",
    }).then((res) => {
      //console.log(res.data);
      this.tx = res.data.data.member.img;
      if (res.data.data.member.img == "") {
        this.tx = "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
      }
      this.my_id = res.data.data.member.id;
      this.member = res.data.data.member;
    });
    /* 推荐列表 */
    this.inittj();
    /* 关注列表 */
    this.initfollow();
    /* 收藏列表 */
    this.initfan();
  },
  activated() {
    this.showPopover = false;
  },
  methods: {
    //to add 分享
    share(id, title, index, list, reportid) {
      this.openShare(title, id, index, list, reportid);
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, id, index, list, reportid) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: "江阴市新时代文明实践中心",
            content:
              "我在看大家参与" + title + "活动的图文及心得，你也快来看一看",
            url: "https://www.jywmsj.com/h5/#/topic?id=" + id, //分享地址
            imgUrl:
              "https://pic-cdn.bigdatajy.com/wenming/static/img/default.png", //分享图标地址
          },
          success: function (ret) {
            //console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            //console.log(ret);
            //console.log(data);
            that.zhuanfa(reportid, index, list);
          },
          error: function (error) {
            that.$toast("分享失败");
            //console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    showmorecomment(list, index) {
      list[index].commentnum += 1;
      this.$forceUpdate();
    },
    preview(imgs, index) {
      //console.log(imgs);
      ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    send(id, pinglun, list, index) {
      this.$axios({
        method: "post",
        url: "/api/report/comment",
        data: this.qs.stringify({
          report_id: id,
          content: pinglun,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("操作成功");
          //console.log(list[index].pinglun);
          list[index].comments.unshift({
            content: list[index].pinglun,
            createtime: Date.parse(new Date()) / 1000,
            id: new Date().valueOf(),
            m_id: this.my_id,
            m_name: this.member.name,
            headimg: this.tx,
          });
          list[index].pinglun = "";
          list[index].showcomment += 1;
          this.$forceUpdate();
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    choosepinglun(list, index) {
      this.chooselist = list;
      this.chooselistindex = index;
      this.show = true;
    },
    test(index) {
      //console.log(index);
    },
    choose() {
      //console.log(event.target.innerText);
      this.chooselist[this.chooselistindex].pinglun = event.target.innerText;
      this.show = false;
    },
    onSelect(action) {
      //console.log(action);
      if (action.className == 0) {
        this.$router.push("/mywishlist");
      }
      if (action.className == 1) {
        this.$router.push("/applywish");
      }
      if (action.className == 2) {
        this.$router.push("/myfav");
      }
    },
    gettab(tid, title) {
      //console.log(tid);
      //console.log(title);
      if (tid == 0) {
        this.inittj();
      } else if (tid == 1) {
        this.initfollow();
      } else if (tid == 2) {
        this.initfan();
      }
      this.$forceUpdate();
    },
    /* 初始化推荐列表 */
    inittj() {
      this.listfjpage = 1;
      this.listfjloading = false;
      this.listfjfinished = false;
      this.listfj = [];
      this.$axios({
        method: "post",
        url: "/api/report/showlist",
        data: this.qs.stringify({}),
      }).then((res) => {
        //console.log(res.data);
        this.listfj = res.data.data.list;
        for (let i in this.listfj) {
          if (this.listfj[i].imgs != "") {
            this.listfj[i].imgs = this.listfj[i].imgs.split(",");
          }
          this.listfj[i].showcomment = 5;
          this.listfj[i].commentnum = 1;
          this.listfj[i].commentnummax = Math.ceil(
            (this.listfj[i].comments.length - this.listfj[i].showcomment) / 10
          );
        }
      });
    },
    /* 初始化关注列表 */
    initfollow() {
      this.listgzpage = 1;
      this.listgzfinished = false;
      this.listgzloading = false;
      this.listgz = [];
      this.$axios({
        method: "post",
        url: "/api/report/showlist",
        data: this.qs.stringify({
          follow: 1,
        }),
      }).then((res) => {
        //console.log(res.data);
        this.listgz = res.data.data.list;
        for (let i in this.listgz) {
          if (this.listgz[i].imgs != "") {
            this.listgz[i].imgs = this.listgz[i].imgs.split(",");
          }
          this.listgz[i].showcomment = 5;
          this.listgz[i].commentnum = 1;
          this.listgz[i].commentnummax = Math.ceil(
            (this.listgz[i].comments.length - this.listgz[i].showcomment) / 10
          );
        }
      });
    },
    /* 初始化收藏列表 */
    initfan() {
      this.listfavpage = 1;
      this.listfavfinished = false;
      this.listfavloading = false;
      this.listfav = [];
      this.$axios({
        method: "post",
        url: "/api/report/showlist",
        data: this.qs.stringify({
          fav: 1,
        }),
      }).then((res) => {
        //console.log(res.data);
        this.listfav = res.data.data.list;
        for (let i in this.listfav) {
          if (this.listfav[i].imgs != "") {
            this.listfav[i].imgs = this.listfav[i].imgs.split(",");
          }
          this.listfav[i].showcomment = 5;
          this.listfav[i].commentnum = 1;
          this.listfav[i].commentnummax = Math.ceil(
            (this.listfav[i].comments.length - this.listfav[i].showcomment) / 10
          );
        }
      });
    },
    listfjload_more() {
      this.listfjpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/report/showlist",
            data: that.qs.stringify({
              page: that.listfjpage,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                if (res.data.data.list[i].imgs != "") {
                  res.data.data.list[i].imgs =
                    res.data.data.list[i].imgs.split(",");
                }
                res.data.data.list[i].showcomment = 5;
                res.data.data.list[i].commentnummax = Math.ceil(
                  (res.data.data.list[i].comments.length -
                    res.data.data.list[i].showcomment) /
                    10
                );
              }
              that.listfj = that.listfj.concat(res.data.data.list);
            }
            that.listfjloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfjfinished = true;
            } else {
              that.listfjfinished = false;
            }
          });
      }, 500);
    },
    listgzload_more() {
      this.listgzpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/report/showlist",
            data: that.qs.stringify({
              page: that.listgzpage,
              follow: 1,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                if (res.data.data.list[i].imgs != "") {
                  res.data.data.list[i].imgs =
                    res.data.data.list[i].imgs.split(",");
                }
                res.data.data.list[i].showcomment = 5;
                res.data.data.list[i].commentnummax = Math.ceil(
                  (res.data.data.list[i].comments.length -
                    res.data.data.list[i].showcomment) /
                    10
                );
              }
              that.listgz = that.listgz.concat(res.data.data.list);
            }
            that.listgzloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listgzfinished = true;
            } else {
              that.listgzfinished = false;
            }
          });
      }, 500);
    },
    listfavload_more() {
      this.listfavpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/report/showlist",
            data: that.qs.stringify({
              page: that.listfavpage,
              fav: 1,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              for (let i in res.data.data.list) {
                if (res.data.data.list[i].imgs != "") {
                  res.data.data.list[i].imgs =
                    res.data.data.list[i].imgs.split(",");
                }
                res.data.data.list[i].showcomment = 5;
                res.data.data.list[i].commentnummax = Math.ceil(
                  (res.data.data.list[i].comments.length -
                    res.data.data.list[i].showcomment) /
                    10
                );
              }
              that.listfav = that.listfav.concat(res.data.data.list);
            }
            that.listfjloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfavfinished = true;
            } else {
              that.listfavfinished = false;
            }
          });
      }, 500);
    },
    totopic(id) {
      this.$router.push({
        name: "topic",
        query: {
          id: id,
        },
      });
    },
    urlchange(url) {
      if (url == "/center") {
        if (!sessionStorage.getItem("wmtoken")) {
          this.$toast("请先加入志愿者");
          return;
        }
      }
      this.$router.push(url);
    },
    //****to add 评论
    //to add 转发
    zhuanfa(id, index, list) {
      this.$axios({
        method: "post",
        url: "/api/report/zhuanfa",
        data: this.qs.stringify({
          report_id: id,
        }),
      }).then((res) => {
        //console.log(res.data);
        list[index].zhuanfa += 1;
        /* if(res.data.code == 0){
          list[index].zhuanfa += 1;
          this.$toast('转发成功');
        }else{
          this.$toast(res.data.msg);
        } */
      });
    },
    //to add 点赞
    dianzan(id, index, list) {
      if (list[index].iszan == 1) {
        //取消
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = null;
            list[index].zan -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //点赞
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = 1;
            list[index].zan += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //to add 收藏
    shoucang(id, index, list) {
      if (list[index].isfav == 1) {
        //取消收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = null;
            list[index].fav -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = 1;
            list[index].fav += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //to add 关注
    follow(id, index, list) {
      if (list[index].isfollow == 1) {
        //取消关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfollow = null;
            this.followrefresh(list, null, list[index].m_id);
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfollow = 1;
            this.followrefresh(list, 1, list[index].m_id);
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //关注之后轮询现有条目
    followrefresh(list, num, id) {
      for (let i in list) {
        if (list[i].m_id == id) {
          list[i].isfollow = num;
        }
      }
      this.$forceUpdate();
    },
    //add 点击头像进入个人主页
    tohomepage(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style scoped>
.container {
  margin-bottom: 50px;
  background: #f8f8f8;
  min-height: 100vh;
}
.tabs /deep/ .van-tabs__wrap {
  padding: 5px 80px;
  background: white;
}
.tabs /deep/ .van-tabs__line {
  background: white;
}
.top {
  position: relative;
}
.tx {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  position: fixed;
  right: 15px;
  top: 7px;
  z-index: 99;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #434343;
  background: white;
}
/* .footer p {
  font-size: 0.289855rem;
} */
.footer div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
}
.icon {
  width: 20px;
  height: 20px;
}
.main {
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  background: white;
  margin-bottom: 10px;
}
.maintop {
  display: flex;
}
.maintop img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.maintop .bt {
  margin-left: auto;
  align-self: center;
  border-radius: 5px;
  padding: 5px 10px;
  white-space: nowrap;
  color: #1646c0;
  font-size: 12px;
}
.pics {
  /* display: flex;
  flex-wrap: wrap; */
  height: 190px;
  width: 100%;
  margin-bottom: 10px;
}
.my-swipe {
  width: 100%;
  height: 190px;
}
.pics img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.date {
  color: #a1a1a1;
  font-size: 12px;
}
.tag {
  font-size: 12px;
}
.tag span {
  color: red;
}
.level {
  font-size: 12px;
}
.content {
  font-size: 14px;
  color: #333;
}
.content span {
  color: #5a7cab;
}
.txsmall {
  width: 10vw;
  height: 10vw;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}
.flex {
  display: flex;
}
.el-textarea {
  width: 100%;
  outline: none;
  border: none;
  background: #f4f5f9;
  border-radius: 30px;
  line-height: 30px;
  font-size: 14px;
  min-height: 30px;
  text-indent: 10px;
}
.el-textarea /deep/ .el-textarea__inner {
  border-radius: 15px;
}
hr {
  margin: 10px 10px 0 10px;
}
.flexicon {
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
}
.flexicon > div {
  /* width: 100%; */
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.flexicon img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.red {
  color: #1646c0 !important;
}
.isfollow {
  color: white;
  background: #cab586;
}
.comments {
  padding: 15px;
}
.comments p {
  margin: 10px auto;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
}
.commentzoom {
  margin: 15px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/cfshow.vue